export default __webpack_public_path__ + "static/media/pdfImage.d6c930ce.png";